var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80483 13.4735L5.4715 16.8062C5.23083 17.0528 4.79817 17.0762 4.52817 16.8062L1.1955 13.4735C0.934833 13.2128 0.934833 12.7915 1.1955 12.5308C1.45617 12.2702 1.8775 12.2702 2.13817 12.5308L4.3335 14.7262V1.66882C4.3335 1.30015 4.6315 1.00215 5.00017 1.00215C5.36817 1.00215 5.66683 1.30015 5.66683 1.66882V14.7262L7.86217 12.5308C8.12283 12.2702 8.54417 12.2702 8.80483 12.5308C9.0655 12.7915 9.0655 13.2128 8.80483 13.4735Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 18,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxIconDown);
export default __webpack_public_path__ + "static/media/mxIconDown.297c84ffdcdb6ce432369e147c7047d8.svg";
export { ForwardRef as ReactComponent };